export const defaultCustomInsoleParameters = {
    selectedTemplateSizeType: "",
    lastSelectedTemplateSizeType: "",
    selectedTemplate: "",
    lastSelectedTemplate: "",
    widthModification: 0,
    archMpfEnabled: false,
    archMpfAdditionalPoints: 4,
    archModification: 0,
    archHeightFittingMethod: "Algorithmic",
    rbwLinesVisible: false,
    sulcusShoeSize: 0,
    plantarVisible: false,
    forefootHeelWidthLinked: false,
    zoningShapesEnabledOnThick: false,
    zoningShapesVisibleOnThick: false,
    zoningShapesEnabledOnLattice: false,
    zoningShapesVisibleOnLattice: false,
    selectedLatticeZoneIndex: 0,
    latticeEnabledZones: [false, false, false, false],
    maxValidCutoutScales: [1, 1, 1, 1]
};
//# sourceMappingURL=parameter-defaults.js.map